import pjax from "./PJAX/index.js";
window.Pjax = pjax;
export default pjax;
